import { CloseButton, CrudMode, Stack, newToast } from "@compass/core";
import { SubmitButton } from "components";
import {
  ApplicationResponseFile,
} from "generated/openApi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";

export const FileDetailHeader = (props: {
  crudMode: CrudMode;
  entityId: Number;
  fileType: string;
  applicationResponseFile: ApplicationResponseFile | undefined;

  onSave: (id: number) => void;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const save = () => {
    // props.setValidationErrors({});
    if (props.fileType == "applicationResponse" && props.applicationResponseFile) {
      ApiService.studentApplications.saveCreateFile(props.applicationResponseFile)
      .then((applicationResponseFileId) => {
        navigate("../");
        dispatch(setAppToast(newToast("success")));
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
      });
    }
  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing="sm">
        Upload File
      </Stack>

      <Stack direction="row" alignItems="center" spacing="sm">
        <CloseButton />

        <SubmitButton
          onClick={() => save()}
          disabled={(props.crudMode != "edit")}
        />
      </Stack>
    </Stack>
  );
};
